import { newsControllerAddNews } from './newsControllerAddNews'
import { newsControllerGetLastNews } from './newsControllerGetLastNews'
import { newsControllerGetNewsById } from './newsControllerGetNewsById'

export const newsService = { newsControllerAddNews, newsControllerGetLastNews, newsControllerGetNewsById }